import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface CustomerAddressProps {
    customerData: CustomerInterface
}

const CustomerAddress: React.FC<CustomerAddressProps> = ({
    customerData
}) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{color: "#333399"}}>住所</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{customerData.ctm_postcode}</Typography>
                <Typography variant="body1">{customerData.ctm_address1}</Typography>
                <Typography variant="body1">{customerData.ctm_address2}</Typography>
                <Typography variant="body1">{customerData.ctm_address3}</Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerAddress